export default "__VITE_ASSET__8b1442be__"